import type { Course } from '../types/course'

export const currentCourse: Course = {
  id: 'ruduo-2026',
  title: 'Savireguliacijos efektas',
  group: 'Rudens grupė',
  start: '2026-09-21',
  end: '2026-11-26',
  weekdays: [0, 1, 3],
  location: 'Vilnius · gyvi mokymai',
  weeks: 10,
  academicHours: 90,
  status: 'current',
  note: 'Registracija atvira',
}

export const futureCourses: Course[] = [
  {
    id: 'pavasaris-2027',
    title: 'Savireguliacijos efektas',
    group: 'Pavasario grupė',
    start: '2027-03-15',
    end: '2027-05-20',
    weekdays: [0, 1, 3],
    location: 'Vilnius · gyvi mokymai',
    weeks: 10,
    academicHours: 90,
    status: 'future',
    note: 'Registracija nuo gruodžio',
  },
]

export const pastCourses: Course[] = [
  {
    id: 'pavasaris-2026',
    title: 'Savireguliacijos efektas',
    group: 'Pavasario grupė',
    start: '2026-03-23',
    end: '2026-05-28',
    weekdays: [0, 1, 3],
    location: 'Vilnius · gyvi mokymai',
    weeks: 10,
    academicHours: 90,
    status: 'past',
    note: 'Grupė pilna',
  },
  {
    id: 'ruduo-2025',
    title: 'Savireguliacijos efektas',
    group: 'Rudens grupė',
    start: '2025-09-01',
    end: '2025-11-06',
    weekdays: [0, 1, 3],
    location: 'Vilnius · gyvi mokymai',
    weeks: 10,
    academicHours: 90,
    status: 'past',
    note: 'Grupė pilna',
  },
]
